<div class="dialog-backdrop" (click)="requestClose()">
  <div class="dialog" role="dialog" aria-modal="true" aria-labelledby="change-password-title" (click)="$event.stopPropagation()">
    <div class="dialog-heading">
      <div>
        <h3 id="change-password-title">Cambiar contraseña</h3>
        <p *ngIf="!succeeded">Ingresa tu contraseña actual y la nueva.</p>
      </div>
      <button type="button" class="icon-button" aria-label="Cerrar" [disabled]="isLoading" (click)="requestClose()">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <form *ngIf="!succeeded" class="form-fields" (ngSubmit)="submit()">
      <label>
        Contraseña actual
        <input type="password" name="currentPassword" [(ngModel)]="form.currentPassword" required
          autocomplete="current-password" />
      </label>

      <label>
        Nueva contraseña
        <input type="password" name="newPassword" [(ngModel)]="form.newPassword" required
          autocomplete="new-password" (input)="onNewPasswordInput()" />
      </label>

      <div *ngIf="passwordStrength" class="strength">
        Seguridad:
        <span [ngClass]="'strength-' + passwordStrength">{{ passwordStrength }}</span>
      </div>

      <label>
        Confirmar nueva contraseña
        <input type="password" name="confirmPassword" [(ngModel)]="form.confirmPassword" required
          autocomplete="new-password" />
      </label>

      <p class="feedback error" *ngIf="errorMessage">{{ errorMessage }}</p>

      <div class="dialog-actions">
        <button class="secondary-action" type="button" [disabled]="isLoading" (click)="requestClose()">Cancelar</button>
        <button class="primary-action" type="submit" [disabled]="isLoading">
          <i *ngIf="isLoading" class="pi pi-spin pi-spinner"></i>
          Cambiar contraseña
        </button>
      </div>
    </form>

    <div *ngIf="succeeded" class="form-fields">
      <p class="feedback success"><i class="pi pi-check-circle"></i> Contraseña actualizada</p>
      <div class="dialog-actions">
        <button class="primary-action" type="button" (click)="requestClose()">Cerrar</button>
      </div>
    </div>
  </div>
</div>
